import { createSelector } from 'reselect';

const selectGlobalOrgRegistrations = (state: any) => state.globalOrgRegistrations;


export const selectGlobalOrgRegistrationsCurrentItem = createSelector([selectGlobalOrgRegistrations], (globalOrgRegistrations) => globalOrgRegistrations.current);

export const selectGlobalOrgRegistrationsListItems = createSelector([selectGlobalOrgRegistrations], (globalOrgRegistrations) => globalOrgRegistrations.list);

export const selectItemById = (itemId: any) =>
    createSelector(selectGlobalOrgRegistrationsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectGlobalOrgRegistrationsQueryItems = createSelector([selectGlobalOrgRegistrations], (globalOrgRegistrations) => globalOrgRegistrations.query);

export const selectGlobalOrgRegistrationsCreatedItem = createSelector([selectGlobalOrgRegistrations], (globalOrgRegistrations) => globalOrgRegistrations.create);

export const selectGlobalOrgRegistrationsUpdatedItem = createSelector([selectGlobalOrgRegistrations], (globalOrgRegistrations) => globalOrgRegistrations.update);

export const selectGlobalOrgRegistrationsReadItem = createSelector([selectGlobalOrgRegistrations], (globalOrgRegistrations) => globalOrgRegistrations.read);

export const selectGlobalOrgRegistrationsDeletedItem = createSelector([selectGlobalOrgRegistrations], (globalOrgRegistrations) => globalOrgRegistrations.delete);

export const selectGlobalOrgRegistrationsSearchedItems = createSelector([selectGlobalOrgRegistrations], (globalOrgRegistrations) => globalOrgRegistrations.search);

export const selectGlobalOrgRegistrationsItemsCount = createSelector([selectGlobalOrgRegistrations], (globalOrgRegistrations) => globalOrgRegistrations.count);

export const selectGlobalOrgRegistrationsItemsFilter = createSelector([selectGlobalOrgRegistrations], (globalOrgRegistrations) => globalOrgRegistrations.filter);